<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getCustomerManagerUserTableRecords"
                    :table-search="mainTable.tableSearch" />
                </Col>
            </Row>
        </transition>
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">客户代理账户列表</span>
                    </div>
                    <div class="right-bar">
                        <Button v-if="$checkAccessArray(['S'])"
                            size="small"
                            class="btns"
                            shape="circle"
                            type="success"
                            icon="ios-add-circle-outline"
                            @click="onCreateCustomerManagerUser">新增</Button>
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.columns"
                    :data="mainTable.data"
                    :extHeight="60"
                    :loading="mainTable.loading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getCustomerManagerUserTableRecords" />
                </Col>
            </Row>
        </Card>

        <CustomerManagerOutsideUserEdit ref="customerManagerOutsideUserModal" />
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { approvalFormat, statusFormat } from '@/libs/baseModelFormat';
import { dateTimeRender } from '@/libs/tableRowTimeRender';
import CustomerManagerOutsideUserEdit from './customerManager-outside-user-edit';
import { getCustomerManagerUserList } from '@/api/modules/account-management/customerManager-user-management';

export default {
    name: 'CustomerManagerOutsideUserList',
    components: {
        SearchCard,
        StandPaginationTable,
        CustomerManagerOutsideUserEdit
    },
    props: {
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            mainTable: {
                columns: [
                    { title: '行号', type: 'index', width: 80, align: 'center' },
                    // { title: '编号', key: 'userCustomerManagerCode', align: 'center' },
                    { title: '姓名', key: 'userCustomerManagerName', align: 'center' },
                    { title: '登录账号', key: 'userName', align: 'center' },
                    { title: '区域', key: 'areaName', width: 80, align: 'center' },
                    // { title: '部门', key: 'projectName', align: 'center' },
                    // { title: '公司', key: 'projectCompany', align: 'center' },
                    { title: '手机号码', key: 'userCustomerManagerPhone', width: 150, align: 'center' },
                    {
                        title: '审核',
                        key: 'userCustomerManagerApproval',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h('div', [
                                h('span', {}, approvalFormat(params.row.userCustomerManagerApproval))
                            ]);
                        }
                    },
                    { title: '创建时间', key: 'userCustomerManagerCreateAt', align: 'center', render: (h, params) => dateTimeRender(h, params.row.userCustomerManagerCreateAt) },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
					   width: 180,
                        render: (h, params) => {
						   const text = this.$checkAccessArray(['S', 'G']) ? '编辑' : '查看';
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style: {},
                                    on: {
                                        click: () => {
                                            this.onUpdateCustomerManagerUser(params.row);
                                        }
                                    }
                                }, text)]);
                        }
                    }
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [
                    { label: '登陆帐号', type: 'Input', value: '', name: 'userName', sql: 'like' },
                    { label: '姓名', type: 'Input', value: '', name: 'userCustomerManagerName', sql: 'like' },
                    { label: '审核状态', type: 'Select', name: 'userCustomerManagerApproval', sql: 'in', options: [{ value: 1, key: '通过' }, { value: 0, key: '未通过' }] }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    created() {
        if (this.readOnly) {
            const findIndex = this.mainTable.columns.findIndex(c => c.title === "操作");
            if (findIndex >= 0) {
                this.mainTable.columns.splice(findIndex, 1);
            }
        }
    },
    mounted() {
        this.getCustomerManagerUserTableRecords();
    },
    methods: {
        getCustomerManagerUserTableRecords(reset = false) {
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "managerType");
            this.mainTable.tableSearch.filters.enable = true;
            this.mainTable.tableSearch.filters.conditions.push({
			    name: 'managerType',
			    type: 'eq',
			    value: 1
            });
            getCustomerManagerUserList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.loading = false;
            }).catch(() => {
                this.mainTable.loading = false;
            });
        },
        onCreateCustomerManagerUser() {
            this.$refs.customerManagerOutsideUserModal.showModal('');
            // this.$router.push({
            //     name: 'customerManager-user-edit',
            //     query: {
            //         userCustomerManagerLoginUuid: ''
            //     }
            // });
        },
        onUpdateCustomerManagerUser(customerManagerUserRow) {
            this.$refs.customerManagerOutsideUserModal.showModal(customerManagerUserRow.userCustomerManagerLoginUuid);
            // this.$router.push({
            //     name: 'customerManager-user-edit',
            //     query: {
            //         userCustomerManagerLoginUuid: customerManagerUserRow.userCustomerManagerLoginUuid
            //     }
            // });
        }
    }
};
</script>

<style scoped>
</style>
